import { BehaviorSubject, combineLatest } from 'rxjs';
import { tag } from 'rxjs-spy/operators';
import { map, switchMap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/fire/firestore";
import * as i2 from "../../authentication/services/auth.service";
export class DataService {
    constructor(db, authService) {
        this.db = db;
        this.authService = authService;
        this.recipeList$ = new BehaviorSubject(null);
        combineLatest(this.publicData(), this.tryData())
            .pipe(map(([publcRecipes, myRecipes]) => [...publcRecipes, ...myRecipes]), map(item => item.sort(this.sortList))).subscribe(data => this.recipeList$.next(data));
    }
    tryData() {
        return this.authService.user.pipe(switchMap(uid => {
            if (uid) {
                return this.personalData(uid.uid);
            }
            else {
                return this.personalData('anonymous');
            }
        }));
    }
    personalData(uid) {
        return this.db.collection('recipes', ref => ref.where('deleted', '==', false)
            .where('visible', '==', false)
            .where('author_uid', '==', uid)
            .orderBy('recipeTitle'))
            .snapshotChanges().pipe(tag('recipeListSwitchMap'), map(data => data.map(a => {
            const data = a.payload.doc.data();
            const id = a.payload.doc.id;
            return Object.assign({ id }, data);
        })));
    }
    publicData() {
        return this.db.collection('recipes', ref => ref.where('deleted', '==', false)
            .where('visible', '==', true)
            .orderBy('recipeTitle'))
            .snapshotChanges().pipe(tag('recipeListPublic'), map(data => data.map(a => {
            const data = a.payload.doc.data();
            const id = a.payload.doc.id;
            return Object.assign({ id }, data);
        })));
    }
    postNote(docId, note) {
        return this.db.collection('recipes').doc(docId).collection('notes').add(note);
    }
    sortList(a, b) {
        if (a.recipeTitle > b.recipeTitle) {
            return 1;
        }
        if (a.recipeTitle < b.recipeTitle) {
            return -1;
        }
        return 0;
    }
}
DataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DataService_Factory() { return new DataService(i0.ɵɵinject(i1.AngularFirestore), i0.ɵɵinject(i2.AuthService)); }, token: DataService, providedIn: "root" });
